export const WELCOME = "/";
export const SIGN_UP = "/signup";
export const LOG_IN = "/login";
export const PASSWORD_FORGET = "/pw-forget";
export const HOME = "/home";
export const ACCOUNT = "/account";
export const CONFIRM = "/confirmation";
export const ABOUT = "/About";
export const FUNDCHOICES = "/FundChoices";
export const PRICING = "/Pricing";
export const ENROLL = "/Enroll";
export const EMPLOYEEINFO = "/EmployeeInfo";
export const FREEGUIDE = "/Free-Guide";
export const GUIDE = "/Guide";
export const NEWS = "/401K-News";



// WEBPACK FOOTER //
// ./src/constants/routes.js